import type {
  Campaign,
  CampaignStep,
} from 'app/src/components/NewUserOnboardingCampaign';

export const splitScreenOnboardingSteps = {
  SELECT_USE_CASE: 'select-use-case', // step 1 of the campaign
  CREATE_INBOX_CARD: 'create-inbox-card', // steps 2-3 of the campaign
  LEARN_INBOX_AND_BOARD: 'learn-inbox-and-board', // steps 4-8 of the campaign
  VERIFY_EMAIL: 'verify-email',
} as const;

export const splitScreenOnboardingCampaign: Campaign<
  'splitscreen',
  typeof splitScreenOnboardingSteps
> = {
  name: 'splitscreen',
  steps: splitScreenOnboardingSteps,
  orderedSteps: [
    splitScreenOnboardingSteps.SELECT_USE_CASE,
    splitScreenOnboardingSteps.CREATE_INBOX_CARD,
    splitScreenOnboardingSteps.LEARN_INBOX_AND_BOARD,
    splitScreenOnboardingSteps.VERIFY_EMAIL,
  ],
  initialStep: splitScreenOnboardingSteps.SELECT_USE_CASE,
  terminalSteps: [splitScreenOnboardingSteps.VERIFY_EMAIL],
};

export type SplitScreenOnboardingCampaign =
  typeof splitScreenOnboardingCampaign;

export type SplitScreenOnboardingStep = CampaignStep<
  SplitScreenOnboardingCampaign,
  typeof splitScreenOnboardingSteps
>;

export const isValidSplitScreenOnboardingStep = (
  step: SplitScreenOnboardingStep,
) => {
  return Object.values(splitScreenOnboardingSteps).includes(step);
};
